import { Box } from '@skin-seoul/design-system';
import type { RecommendedProduct } from '@skin-seoul/service';
import RecentlyViewedProductsScroll from './RecentlyViewedProductsScroll';
import RecentlyViewProductCarousel from './RecentlyViewProductCarousel';
type RecentlyViewedSectionProps = {
  isFetching: boolean;
  selectedProductId?: number;
  onProductClick: (productId: number, productLink: string) => void;
  recentlyViewedProducts: RecommendedProduct[];
};
const RecentlyViewedSection = ({
  isFetching,
  selectedProductId,
  onProductClick,
  recentlyViewedProducts
}: RecentlyViewedSectionProps) => {
  if (isFetching) {
    return <>
        <Box width="100%" overflow="hidden" display={{
        base: 'block',
        desktop: 'none'
      }}>
          <RecentlyViewedProductsScroll.Skeleton />
        </Box>
        <Box width="fit-content" display={{
        base: 'none',
        desktop: 'block'
      }}>
          <RecentlyViewProductCarousel.Skeleton />
        </Box>
      </>;
  }
  return <>
      <Box width="100%" overflow="hidden" display={{
      base: 'block',
      desktop: 'none'
    }} data-sentry-element="Box" data-sentry-source-file="RecentlyViewedSection.tsx">
        <RecentlyViewedProductsScroll selectedProductId={selectedProductId} onProductClick={onProductClick} recentlyViewedProducts={recentlyViewedProducts} data-sentry-element="RecentlyViewedProductsScroll" data-sentry-source-file="RecentlyViewedSection.tsx" />
      </Box>
      <Box width="fit-content" display={{
      base: 'none',
      desktop: 'block'
    }} data-sentry-element="Box" data-sentry-source-file="RecentlyViewedSection.tsx">
        <RecentlyViewProductCarousel recentlyViewedProducts={recentlyViewedProducts} data-sentry-element="RecentlyViewProductCarousel" data-sentry-source-file="RecentlyViewedSection.tsx" />
      </Box>
    </>;
};
export default RecentlyViewedSection;